/**
 * Created by Mehraz on 2022-02-22.
 */
import router from '../../router'
import {addDoc, collection, doc, getDoc, setDoc, updateDoc} from "firebase/firestore";
import {getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut} from "firebase/auth";
export default {
  state: {
    user: null,
    users: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    }
  },
  actions: {
      setUserData ({commit}, payload) {
          commit('setUser', payload)
      },
      signUserIn ({commit, rootState, dispatch}, payload) {
      commit('setLoading', true)
      commit('clearError')
      let auth = getAuth()
      signInWithEmailAndPassword(auth, payload.email, payload.password)
          .then(user => {
            commit('setLoading', false)
              dispatch('fetchUserData', {uid: user.user.uid, phoneNumber: user.user.phoneNumber})
            let db = rootState.db
            return addDoc(collection(db, 'serviceProviders', user.user.phoneNumber, 'logins'), {
              ...user.user.reloadUserInfo}, { merge: true })
          })
          .catch(error => {
                console.log(error)
                commit('setLoading', false)
                commit('setError', error)
              }
          )
    },
      fetchUserData ({commit, rootState}, payload) {
        commit('setLoading', true)
        let userRef = doc(rootState.db, 'serviceProviders', payload.phoneNumber)
        getDoc(userRef)
            .then(doc => {
                // console.log(doc)
            if (doc.exists) {
                const data = doc.data()
                // console.log(data)
                const userProfile = {
                  ...data,
                  emailVerified: payload.emailVerified
                }
                commit('setUser', userProfile)
            }
                commit('setLoading', false)
            })
            .catch(error => {
                console.log('in fetch user data')
                // console.log(payload)
                console.log(error)
                commit('setError', error)
                commit('setLoading', false)
        })
    },
      onSignUp ({rootState, commit, dispatch}, payload) {
        let userInfo = {name: payload.name, email: payload.email, password: payload.password}
        let auth = getAuth()
        let user
        commit('setLoading', true)
        createUserWithEmailAndPassword(auth, userInfo.email, userInfo.password)
            .then((userCredential) => {
                // Signed in
                user = userCredential.user;
                let db = rootState.db
                let userObj = {
                    uid: user.uid,
                    name: userInfo.name,
                    email: userInfo.email
                }
                commit('setUser', userObj)
                return setDoc(doc(db, 'serviceProviders', user.phoneNumber), userObj, { merge: true })
            })
            .then(() => {
                dispatch('fetchUserData', {uid: user.uid, phoneNumber: user.phoneNumber})
                router.push('/')
                commit('setLoading', false)
            })
            .catch((error) => {
                commit('setLoading', false)
                commit('setError', error)
                console.log(error)
            });
      },
      updateUserProfile({commit, rootState}, payload) {
          commit('setLoading', true)
          let userRef = doc(rootState.db, 'serviceProviders', payload.phoneNumber)
          updateDoc(userRef, payload)
              .then(() => {
                  commit('setLoading', false)
              })
              .catch(error => {
                  console.log(error)
                  commit('setError', error)
                  commit('setLoading', false)
              })
      },
    clearError ({commit}) {
      commit('clearError')
    },
    logout ({commit}) {
        let auth = getAuth()
        signOut(auth)
            .then(() => {
                console.log('user signed out')
                router.push('/')
            })

        commit('setUser', null)
    }
  },
  getters: {
    user (state) {
      return state.user
    }
  }
}
